module.exports = __webpack_public_path__ + "img/menu-state-active.f5c976f8.svg";